import { Client, createClient, dedupExchange, fetchExchange } from 'urql';
import { DEFAULT_SUBGRAPH_URL } from 'web3/constants';

export const client: Client = createClient({
  url: DEFAULT_SUBGRAPH_URL,
  exchanges: [dedupExchange, fetchExchange],
});
